import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateProviderInvoiceReport = (apiData) => async (dispatch) => {
 try {
  const response = await axios({
   method: "get", // Change GET to POST
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/provider/GenerateProviderInvoiceReport`,
   params: {
    ...apiData,
  
    // provider_org_ids: JSON.stringify(
    //     apiData.provider_org_ids
    //   ),
    provider_org_ids: JSON.stringify(
      apiData.provider_org_ids?.map((item) => item?.provider_org_id)
    ),
   },
  });

  return response.data;
 } catch (error) {
  return error.message;
 }
};

export const TriggerProviderInvoiceReport = (apiData) => async (dispatch) => {
 try {
  const response = await axios({
   method: "post",
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/TriggerProviderInvoiceReport`,
   data: {
    ...apiData,
    provider_org_ids: JSON.stringify(
      apiData.provider_org_ids?.map((item) => item?.provider_org_id) || []
    ),
   },
  });

  return response.data;
 } catch (error) {
  return error.message;
 }
};